import {style} from 'typestyle'
import * as csstips from 'csstips'

export const HomeRankingModule = style({
    boxShadow: '0 5px 8px 0 rgba(51,51,51,0.05)',
    borderRadius: 8,
    maxWidth: 450,
    position: 'relative',
    width: '92vw',
    margin: '0 auto',
    marginBottom: 15,
    background: '#fff'
})

export const title = style({
    fontSize: 20,
    color: '#000000',
    letterSpacing: 0,
    lineHeight: '20px',
    fontWeight: 500,
    paddingRight: 15,
    paddingLeft: 15,
    paddingTop: 15,
    paddingBottom: 14
})

export const HomeRankingContentLeft = style({})

export const HomeRankingContentWrapNormal = style({
    background: '#fff',
    // width: '40.53vw',
    // maxWidth: 194.56,
    borderRadius: 10,
    width: 'calc(50% - 5px)',
    // boxShadow: '0 2px 5px 0 rgba(0,0,0,0.10)',
    marginBottom: 15
    // $nest: {
    //     '&:active': {
    //         backgroundColor: '#f8f8f8'
    //     }
    // }
})

export const HomeRankingContentTop = style({})

export const HomeRankingContentWrap = style({
    position: 'relative',
    // marginLeft: 15,
    // marginRight: 15,
    background: '#FFFFFF',
    // boxShadow: '0 2px 5px 0 rgba(0,0,0,0.10)',
    margin: '0px 15px 15px 15px',
    paddingTop: 15,
    paddingBottom: 15,
    ...csstips.flexRoot,
    $nest: {
        '&:after': {
            content: `""`,
            position: 'absolute',
            width: '100%',
            height: 1,
            background: '#f0f0f0',
            bottom: 0,
            transform: 'scaleY(0.5)'
        }
        // '&:active': {
        //     backgroundColor: '#f8f8f8'
        // }
    }
})

export const HomeRankingCover = style({
    position: 'relative',
    width: '41vw',
    height: '24.8vw',
    maxWidth: 196.8,
    maxHeight: 119,
    backgroundSize: 'cover',
    borderRadius: 6,
    overflow: 'hidden',
    $nest: {
        picture: {
            $nest: {
                img: {
                    height: '100%'
                }
            }
        }
    }
})

export const HomeRankingCoverNormal = style({
    position: 'relative',
    height: '22.13vw',
    maxHeight: 106,
    backgroundSize: 'cover',
    borderRadius: 6,
    overflow: 'hidden'
})

export const HomeRankingContentRight = style({
    ...csstips.flexRoot,
    flexDirection: 'column',
    ...csstips.betweenJustified,
    marginLeft: 10,
    width: '37.86vw',
    maxWidth: 202

})

export const HomeRankingContentBottom = style({
    ...csstips.flexRoot,
    flexDirection: 'column',
    ...csstips.betweenJustified,
    marginTop: 10
})

export const HomeRankingContentRightTitle = style({
    fontSize: 16,
    color: '#333333',
    lineHeight: '22px',
    marginBottom: 13,
    height: 44,
    fontWeight: 500
})

export const HomeRankingContentButton = style({
    ...csstips.betweenJustified,
    ...csstips.flexRoot
})

export const popularNum = style({
    ...csstips.flexRoot,
    ...csstips.center,
    $nest: {
        img: {
            position: 'relative',
            top: -1,
            width: 10,
            display: 'inline-block'
        },
        p: {
            fontSize: 12,
            color: '#999999',
            letterSpacing: 0,
            lineHeight: '12px',
            display: 'inline-block',
            marginLeft: 5
        }
    }
})

export const listenBtn = style({
    cursor: 'pointer',
    background: '#FF5A31',
    boxShadow: '0 3px 5px 0 rgba(255,90,49,0.40)',
    borderRadius: 50,
    // width: '20vw',
    // height: '8.5vw',
    ...csstips.flexRoot,
    ...csstips.center,
    ...csstips.content,
    // maxWidth: 75,
    // maxHeight: 32,
    $nest: {
        'img': {
            width: 12,
            marginRight: 5,
            $nest: {
                '@media (max-width: 330px)': {
                    width: 8
                }
            }
        },
        'i': {
            fontStyle: 'normal',
            fontSize: 14,
            fontWeight: 500,
            color: '#fff',
            $nest: {
                '@media (max-width: 330px)': {
                    fontSize: 10
                }
            }
        },
        '&:active': {
            background: '#f05d39'
        }
    }
})

export const noramlRankList = style({
    ...csstips.flexRoot,
    ...csstips.betweenJustified,
    ...csstips.wrap,
    position: 'relative',
    margin: '0 auto',
    marginTop: 5,
    // marginBottom: 10,
    // marginLeft: 15,
    // marginRight: 15,
    width: 'calc(100% - 30px)'
})

export const RankCoverTag = style({
    position: 'absolute',
    width: '17.33vw',
    maxWidth: 83.2,
    bottom: 0,
    right: 0
})

export const RankCoverTagNormal = style({
    position: 'absolute',
    width: '14.13vw',
    maxWidth: 67.84,
    bottom: 0,
    right: 0
})

export const playBtn = style({
    padding: '8px 15px 8px 15px',
    cursor: 'pointer',
    ...csstips.flexRoot,
    ...csstips.center,
    $nest: {
        '@media (max-width: 330px)': {
           padding: '7px 11px 7px 11px'
        }
    }
})

export const activityHeader = style({
    backgroundImage: 'url(https://static-cos.lycheer.net/picture/12209467_f108f8ea1f4f4ddce4a7588dd878464b.jpg)',
    backgroundSize: '100% 100%',
    width: '74.66vw',
    maxWidth: 358.4,
    height: '9.6vw',
    maxHeight: 46.08,
    marginLeft: 15,
    marginTop: 15
})

export const HomePictureViewInActivity = style({
    border: '4px solid #FF802F',
    background: '#fff',
    borderRadius: 8,
    position: 'relative',
    top: -1,
    marginLeft: 15,
    marginRight: 15,
    marginBottom: 19,
    $nest: {
        '&::before': {
            content: `""`,
            position: 'absolute',
            left: -4,
            top: -4,
            width: 0,
            height: 0,
            borderTop: '10px solid #FF802F',
            borderRight: '10px solid transparent'
        }
    }
})

export const isActivity = style({
    boxShadow: 'none',
    width: 'auto',
    marginBottom: 0
})

export const activitySpecialReturn = style({
    borderRadius: 2,
    fontSize: 10,
    color: '#FFFFFF',
    letterSpacing: 0,
    background: '#F44336',
    lineHeight: '14px',
    padding: '1px 3px 1px 3px',
    position: 'relative',
    top: -2,
    marginRight: 3
})



// WEBPACK FOOTER //
// ./src/views/Home/components/TriennialsSpecial/HomeRankingModule/HomeRankingModule.style.ts